const generateGoogleMapsUrl = (row) => {
    if (row.locationUrl) {
        return row.locationUrl;
    } else if (row.latitude && row.longitude) {
        return `https://www.google.com/maps/search/?api=1&query=${row.latitude},${row.longitude}`;
    } else {
        return "";
    }
};

export { generateGoogleMapsUrl };
